import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, LockKeyhole } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

import logo3c from "@/assets/logo-3c-jatim.jpg";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#090A0F] px-4">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
        className="w-full max-w-md space-y-6 rounded-xl border border-white/10 bg-[#12141C]/90 p-8 shadow-2xl shadow-black/60">
        <div className="space-y-3 text-center">
          <img
            src={logo3c}
            alt="Logo 3C Jatim"
            className="mx-auto h-16 w-16 rounded-full object-cover border-2 border-rose-500/40 shadow-xl shadow-rose-600/40"
          />
          <h1 className="font-heading text-3xl font-bold uppercase text-white">Login Pengurus</h1>
          <p className="text-sm text-slate-400">Area khusus pengurus 3C Chapter Jatim</p>
        </div>
        {error && (
          <p data-testid="admin-login-error" className="rounded-md border border-rose-500/40 bg-rose-500/10 px-4 py-3 text-sm text-rose-400">{error}</p>
        )}
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="admin-email" className="text-slate-300">Email</Label>
            <Input id="admin-email" data-testid="admin-login-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="admin@3cjatim.id"
              className="border-white/10 bg-[#0B0D15] text-slate-200 placeholder:text-slate-500" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-password" className="text-slate-300">Password</Label>
            <Input id="admin-password" data-testid="admin-login-password-input" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
              className="border-white/10 bg-[#0B0D15] text-slate-200 placeholder:text-slate-500" />
          </div>
          <Button data-testid="admin-login-submit-button" type="submit" disabled={loading}
            className="w-full bg-rose-600 py-5 font-bold text-white shadow-lg shadow-rose-600/30 hover:bg-rose-500">
            <LockKeyhole className="mr-2 h-4 w-4" /> {loading ? "Memeriksa..." : "Masuk Dashboard"}
          </Button>
        </form>
        <Link to="/" data-testid="admin-login-back-home" className="flex items-center justify-center gap-2 text-sm text-slate-400 hover:text-rose-400">
          <ArrowLeft className="h-4 w-4" /> Kembali ke Beranda
        </Link>
      </motion.div>
    </div>
  );
}
